import { Pipe, PipeTransform } from '@angular/core';
import { UnitConversionService } from '../services/unit-conversion.service';
import { UnitQuantity, UnitSystem } from '../models/unit.model';

// Impure: formatting also depends on the service's densityVariant/massVariant
// signals, which are not pipe arguments — a pure pipe would keep serving the
// cached value after the user switches variant in Project Settings.
@Pipe({
  name: 'unit',
  standalone: true,
  pure: false,
})
export class UnitPipe implements PipeTransform {
  constructor(private unitService: UnitConversionService) {}

  transform(value: number | null | undefined, quantity: UnitQuantity, system: UnitSystem): string {
    if (value == null || isNaN(value)) return 'n/a';
    return this.unitService.format(value, quantity, system);
  }
}
